// reduxjs toolkit
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../service/API/base_url";
import { handleSuccess, handleError } from "../../utils/toast";

const handleApiResponse = (response, thunkAPI, successMessage) => {
  if (response.status === 200 || response.status === 201) {
    if (successMessage) handleSuccess(successMessage);
    return response.data;
  } else {
    handleError(response.message);
    return thunkAPI.rejectWithValue(response.data);
  }
};

const handleApiError = (error, thunkAPI, errorMessage) => {
  handleError(error.response?.data?.message || errorMessage);
  return thunkAPI.rejectWithValue(error.response?.data);
};

// List all Partners
export const viewPartners = createAsyncThunk(
  "partners",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${BaseUrl}backend-api/partners/data`);
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "loading...");
    }
  },
);

// Add new partners
export const registerPartners = createAsyncThunk(
  "partners",
  async (partnersData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BaseUrl}backend-api/partners`,
        partnersData,
      );
      //  console.log("response : ", response);
      return handleApiResponse(response, thunkAPI, "Register successful!");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  },
);

// Search Partners by ID
export const singlePartners = createAsyncThunk(
  "partners",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${BaseUrl}backend-api/partners/${id}`);
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "search maintenance history...");
    }
  },
);

// Update Partners
export const updatePartners = createAsyncThunk(
  "partners",
  async ({ id, formData }, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BaseUrl}backend-api/partners/${id}`,
        formData,
      );
      return handleApiResponse(response, thunkAPI, "Change saved successfully");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  },
);

// Delete Partners
export const deletePartners = createAsyncThunk(
  "partners",
  async (id, thunkAPI) => {
    const token = JSON.parse(localStorage.getItem("userInfo")) || null;
    try {
      const response = await axios.delete(
        `${BaseUrl}backend-api/partners/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      return handleApiResponse(response, thunkAPI, "Delete successful!");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  },
);
